<p-toolbar styleClass="bg-white border-0 py-0 pr-2 pl-2 lg:pr-4 lg:pl-4">
    <ng-template pTemplate="start">
        <div class="p-0">
            <h2 class="mb-0 pb-0">{{ pageTitle }}</h2>
            <p class="text-xl">{{ pageSubTitle }}</p>
        </div>
    </ng-template>

    <ng-template pTemplate="end">
        @for(navItem of buttonItems; track navItem){
        @if(navItem.link){
        <button [routerLink]="navItem.link" class="bg-primary flex align-items-center flex-wrap block mr-2"
            [icon]="navItem?.icon!" pButton type="button" [disabled]="navItem?.disabled" name="next">
            {{navItem.btnLabel}}
        </button>
        } @else{
        <button class="bg-primary flex align-items-center flex-wrap block mr-2" (click)="navItem?.onClick()"
            [icon]="navItem?.icon!" pButton type="button" [disabled]="navItem?.disabled" name="next">
            {{navItem.btnLabel}}
        </button>
        }
        }
    </ng-template>

</p-toolbar>